<template>
  <router-view></router-view>
</template>

<script>
import '@progress/kendo-theme-default/dist/all.css';

export default {
  name: 'App'
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';



  .mySearchPanel{
    max-width: 1600px;
  }

  .mySearchPanel_toolbar{
    max-width: 1600px;
  }
  .myFormContainer{
    max-width: 1024px;
  }

  .mySearchPanel{
    max-width: 1600px;
  }

  .mySearchPanel_txtKeyword {
    width: 300px !important;
    display: inline !important;
  }

  .myGridPanel{
    max-width: 1600px;
  }

  .mybutton{
    color: white !important;
    margin: 10px;
  }

  .errorAdm{
    border-color:red;
  }

  .message{
    border-color:red;
    color: red;
  }
  .require{
    color: red;
  }

  .myInput_Date{
    max-width: 185px;
    display: inline;
    padding: 0px;
  }
  .myInput_DateTime{
    max-width: 230px;
    display: inline;
    padding: 0px;
  }

  .sidebar{
    width: 18em !important;
  }

  .btn{
    color: white !important;
    margin-left:5px;
  }
</style>
